import { useEffect } from 'react';

import type { LinksFunction, MetaFunction } from '@remix-run/node';

import { addOfferToLocalStorage } from '@/constants/dboo/urls';
import {
  SharedFooter,
  links as sharedFooterLinks,
} from '@/components/shared/shared-footer/shared-footer';
import {
  SharedHeader,
  links as sharedHeaderLinks,
} from '@/components/shared/shared-header/shared-header';
import {
  DbooRunSection,
  links as dbooRunSectionLinks,
} from '@/components/dboo/dboo-run-section/dboo-run-section';
import {
  DbooExplainerSection,
  links as dbooExplainerSectionLinks,
} from '@/components/dboo/dboo-explainer-section/dboo-explainer-section';
import DbooFrequentlyAskedQuestions, {
  links as dbooFrequentlyAskedQuestionsStyles,
} from '@/components/dboo/dboo-faq/dboo-faq';
import {
  SharedAnnouncementBar,
  links as sharedAnnouncementBarLinks,
} from '@/components/shared/shared-announcement-bar/shared-announcement-bar';

import { DBOO_META_TAGS } from '@/constants/dboo/meta';

import styles from './index.css?url';

export const meta: MetaFunction = () => {
  return [...DBOO_META_TAGS];
};

export const links: LinksFunction = () => [
  { rel: 'stylesheet', href: styles },
  ...sharedHeaderLinks(),
  ...dbooRunSectionLinks(),
  ...dbooExplainerSectionLinks(),
  ...dbooFrequentlyAskedQuestionsStyles(),
  ...sharedFooterLinks(),
  ...sharedAnnouncementBarLinks(),
];

export default function DbooHomePage() {
  useEffect(() => {
    addOfferToLocalStorage();
  }, []);

  return (
    <main className="dboo-home-page">
      <div className="dboo-home-page__bottom-glow">
        <SharedHeader />
        <SharedAnnouncementBar />
        <DbooRunSection
          title="It’s your data. Let’s keep it that way."
          subtitle="Request free removal from data brokers to protect your privacy, preventing spam calls, junk mail, and even identity theft."
          actionLabel="Start FREE removal"
          className="dboo-home-page__run-section"
        />
      </div>
      <DbooExplainerSection className="dboo-pull-up-section" />
      <div className="dboo-home-page__bottom-glow dboo-pull-up-section">
        <DbooRunSection
          title="Secure your privacy from data brokers"
          subtitle="Data brokers could be putting you at risk. Run a scan to find out who has your info, and request removal for FREE."
          actionLabel="Protect my data"
        />
      </div>
      <DbooFrequentlyAskedQuestions />
      <SharedFooter theme="light" withDisclaimer />
    </main>
  );
}
